import  gql  from 'graphql-tag'

export const CREATE_ACCOUNT_TYPE = gql`mutation accountType($input: AccountTypeMutationInput!){
    accountType(input: $input){
        accountType{
            id
            code
            name
            isActive
        }
        errors{
            field
            messages
        }
    }
}`;